import React, {Component, Suspense} from 'react';
import {connect} from "react-redux";
import {message, Row} from 'antd';
import {
	convexityRangeChanged,
	eccentricityRangeChanged,
	extremeConvexityRangeChanged,
	extremeEccentricityRangeChanged,
	extremeMeanColorRangeChanged,
	extremeSizeRangeChanged,
	meanColorRangeChanged,
	sizeRangeChanged
} from "../redux_actions/bloodGridRBC.action";
import {extremeSizeRangeChangedPLT, sizeRangeChangedPLT} from '../redux_actions/bloodGridPLT.action';
import {bloodClass} from '../utils/const';
import {notNull} from "../utils/utils";
import {get_response} from "../helper/request";
const Plot = React.lazy(() => import("react-plotly.js"));

export class BloodGraph extends Component {

	constructor(props) {
		super(props);

		this.containerRef = React.createRef();

		this.state = {
			size: [],
			convexity: [],
			eccentricity: [],
			meancolor: [],
		}

	}

    getHistogramDataRBC = () => {
        let url = `/api/get_histogram_data_rbc/?slide_id=${this.props.slide_id}`
        get_response(url).then(res => {
	        let size = res.data['size']
	        let convexity = res.data['convexity']
	        let eccentricity = res.data['eccentricity']
	        let meancolor = res.data['meancolor']
	        this.setState({
		        size: size,
		        convexity: convexity,
		        eccentricity: eccentricity,
		        meancolor: meancolor,
	        })
	        this.props.dispatch(extremeSizeRangeChanged([Math.min(...size), Math.max(...size)]))
	        this.props.dispatch(extremeConvexityRangeChanged([Math.min(...convexity), Math.max(...convexity)]))
	        this.props.dispatch(extremeEccentricityRangeChanged([Math.min(...eccentricity), Math.max(...eccentricity)]))
	        this.props.dispatch(extremeMeanColorRangeChanged([Math.min(...meancolor), Math.max(...meancolor)]))
	        this.props.dispatch(sizeRangeChanged([Math.min(...size), Math.max(...size)]))
	        this.props.dispatch(convexityRangeChanged([Math.min(...convexity), Math.max(...convexity)]))
	        this.props.dispatch(eccentricityRangeChanged([Math.min(...eccentricity), Math.max(...eccentricity)]))
	        this.props.dispatch(meanColorRangeChanged([Math.min(...meancolor), Math.max(...meancolor)]))
        })
    }

    getHistogramDataPLT = () => {
        let url = `/api/get_histogram_data_plt/?slide_id=${this.props.slide_id}`
        get_response(url).then(res => {
	        let size = res.data['size']
	        this.setState({
		        size: size,
	        })
	        console.debug("changeme-size01")
	        this.props.dispatch(extremeSizeRangeChangedPLT([Math.min(...size), Math.max(...size)]))
	        this.props.dispatch(sizeRangeChangedPLT([Math.min(...size), Math.max(...size)]))
        })
    }

    componentDidMount = () => {
	    if (this.props.class === bloodClass.RBC) {
		    this.getHistogramDataRBC();
	    } else if (this.props.class === bloodClass.PLT) {
		    this.getHistogramDataPLT();
	    }
    }

	componentDidUpdate = (prevProps) => {

	}


	componentWillUnmount = () => {

	}

	plotUpdateSize = (figure) => {
		if (notNull(figure['xaxis.range[0]'])) {
			this.props.dispatch(sizeRangeChanged([figure['xaxis.range[0]'], figure['xaxis.range[1]']]))
			message.success('Area Filter Applied Successfully', 2.5);
		} else if (figure['xaxis.autorange']) {
			this.props.dispatch(sizeRangeChanged([this.props.data.extreme_size_range_low, this.props.data.extreme_size_range_high]))
			message.success('Area Filter Reset Successful', 2.5);
		}
	}

	plotUpdateSizePLT = (figure) => {
		if (notNull(figure['xaxis.range[0]'])) {
			this.props.dispatch(sizeRangeChangedPLT([figure['xaxis.range[0]'], figure['xaxis.range[1]']]))
			message.success('Area Filter Applied Successfully', 2.5);
		} else if (figure['xaxis.autorange']) {
			this.props.dispatch(sizeRangeChangedPLT([this.props.data.extreme_size_range_low, this.props.data.extreme_size_range_high]))
			message.success('Area Filter Reset Successful', 2.5);
		}
	}

	plotUpdateConvexity = (figure) => {
		if (notNull(figure['xaxis.range[0]'])) {
			this.props.dispatch(convexityRangeChanged([figure['xaxis.range[0]'], figure['xaxis.range[1]']]))
			message.success('Convexity Filter Applied Successfully', 2.5);
		} else if (figure['xaxis.autorange']) {
			this.props.dispatch(convexityRangeChanged([this.props.data.extreme_convexity_range_low, this.props.data.extreme_convexity_range_high]))
			message.success('Convexity Filter Reset Successful', 2.5);
		}
	}

	plotUpdateEccentricity = (figure) => {
		if (notNull(figure['xaxis.range[0]'])) {
			this.props.dispatch(eccentricityRangeChanged([figure['xaxis.range[0]'], figure['xaxis.range[1]']]))
			message.success('Eccentricity Filter Applied Successfully', 2.5);
		} else if (figure['xaxis.autorange']) {
			this.props.dispatch(eccentricityRangeChanged([this.props.data.extreme_eccentricity_range_low, this.props.data.extreme_eccentricity_range_high]))
			message.success('Eccentricity Filter Reset Successful', 2.5);
		}
	}

	plotUpdateMeanColor = (figure) => {
		if (notNull(figure['xaxis.range[0]'])) {
			this.props.dispatch(meanColorRangeChanged([figure['xaxis.range[0]'], figure['xaxis.range[1]']]))
			message.success('Pallor Filter Applied Successfully', 2.5);
		} else if (figure['xaxis.autorange']) {
			this.props.dispatch(meanColorRangeChanged([this.props.data.extreme_mean_color_range_low, this.props.data.extreme_mean_color_range_high]))
			message.success('Pallor Filter Reset Successful', 2.5);
		}
	}

	getSizeData = (data) => {
		return data.filter((val) => {
			return (val >= this.props.data.size_range_low && val <= this.props.data.size_range_high);
		});
	}

    getEccentricitydata = (data) => {
	    return data.filter((val) => {
		    return (val >= this.props.data.eccentricity_range_low && val <= this.props.data.eccentricity_range_high);
	    });
    }

    getConvexityData = (data) => {
	    return data.filter((val) => {
		    return (val >= this.props.data.convexity_range_low && val <= this.props.data.convexity_range_high);
	    });
    }

	getMeanColorData = (data) => {
		return data.filter((val) => {
			return (val >= this.props.data.mean_color_range_low && val <= this.props.data.mean_color_range_high);
		});
	}

	getGraphLayout = (label) => {
		const isSmallY = document.documentElement.clientWidth < 700
		const isSmallX = document.documentElement.clientHeight < 600
		return {
			paper_bgcolor: 'rgba(0,0,0,0)',
			plot_bgcolor: "rgba(0,0,0,0)",
			font: {
				size: 11,
				color: 'white'
			},
			uirevision: 'true',
			margin: {
				l: 30,
				r: 10,
				b: isSmallY && !isSmallX ? 45 : 30,
				t: 10,
			},
			xaxis: {
				title: {
					text: isSmallY && isSmallX ? '' : `${label}`
				},
				autorange: 'true',
			},
			yaxis: {
				title: {
					text: isSmallY ? '' : 'Count'
				},
				fixedrange: true
			},
			bargap: "0.4"
		};
	}


	render() {

		let boundingHeight = 1080;
		if (notNull(this.containerRef.current)) {
			boundingHeight = (this.containerRef.current || {}).clientHeight - 40;
		}

		let graphs;
		let numRows = 1;

		let graphConfig = {
			modeBarButtonsToRemove: ['lasso2d', 'zoom2d', 'pan2d', 'select2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d', 'toggleSpikelines', 'hoverClosestCartesian',
				'hoverCompareCartesian'],
			displaylogo: false,
			responsive: true
		}

		if (this.props.class === bloodClass.RBC) {
			numRows = 4;
			graphs = <div className={'full-parent'} style={{height: '95%', maxHeight: boundingHeight}}>
				<Row className={'full-width'} style={{height: `${100 / numRows}%`, padding: '2%'}}>
					<Suspense fallback={<div>Loading...</div>}>
						<Plot
							onRelayout={this.plotUpdateSize}
							className={"full-parent"}
							data={
								[
									{
										x: this.getSizeData(this.state.size),
										type: 'histogram',
										mode: 'lines+markers',
										marker: {color: '#1cb2ba'},
									}
								]
							}
							layout={this.getGraphLayout(`Size ( µ )`)}
							config={graphConfig}
						/>
					</Suspense>
				</Row>
				<Row className={'full-width'} style={{height: `${100 / numRows}%`, padding: '2%'}}>
					<Suspense fallback={<div>Loading...</div>}>
						<Plot
							onRelayout={this.plotUpdateConvexity}
							className={"full-parent"}
							data={
								[
									{
										x: this.getConvexityData(this.state.convexity),
										type: 'histogram',
										mode: 'lines+markers',
										marker: {color: '#1cb2ba'},
									}
								]
							}
							layout={this.getGraphLayout('Unevenness')}
							config={graphConfig}
						/>
					</Suspense>
				</Row>
				<Row className={'full-width'} style={{height: `${100 / numRows}%`, padding: '2%'}}>
					<Suspense fallback={<div>Loading...</div>}>
						<Plot
							onRelayout={this.plotUpdateEccentricity}
							className={"full-parent"}
							data={
								[
									{
										x: this.getEccentricitydata(this.state.eccentricity),
										type: 'histogram',
										mode: 'lines+markers',
										marker: {color: '#1cb2ba'},
									}
								]
							}
							layout={this.getGraphLayout('Elongation')}
							config={graphConfig}
						/>
					</Suspense>
				</Row>
				{this.props.data.extreme_mean_color_range_low !== 0 && this.props.data.extreme_mean_color_range_high !== 0 ?
					<Row className={'full-width'} style={{height: `${100 / numRows}%`, padding: '2%'}}>
						<Suspense fallback={<div>Loading...</div>}>
							<Plot
								onRelayout={this.plotUpdateMeanColor}
								className={"full-parent"}
								data={
									[
										{
											x: this.getMeanColorData(this.state.meancolor),
											type: 'histogram',
											mode: 'lines+markers',
											marker: {color: '#1cb2ba'},
										}
									]
								}
								layout={this.getGraphLayout('Pallor Size')}
								config={graphConfig}
							/>
						</Suspense>
					</Row> : null}
			</div>
		} else if (this.props.class === bloodClass.PLT) {
			numRows = 1;
			graphs = <div className={'full-parent'} style={{height: '95%', maxHeight: boundingHeight}}>
				<Row className={'full-width'}
				     style={{height: `${100 / numRows}%`, padding: '2%', maxHeight: `${100 / 3}%`}}>
					<Suspense fallback={<div>Loading...</div>}>
						<Plot
							onRelayout={this.plotUpdateSizePLT}
							className={"full-parent"}
							data={
								[
									{
										x: this.getSizeData(this.state.size),
										type: 'histogram',
										mode: 'lines+markers',
										marker: {color: '#1cb2ba'},
									}
								]
							}
							layout={this.getGraphLayout('Size ( µ )')}
							config={graphConfig}
						/>
					</Suspense>
				</Row>
			</div>
		}

        return (
	        <div className={'full-parent'} ref={this.containerRef}>
		        {graphs}
	        </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
	    bloodGridRBCData: state.bloodGridRBCReducer,
    }
};

export default connect(mapStateToProps)(BloodGraph);
